// extracted by mini-css-extract-plugin
module.exports = {"SupporterList":"ComponentBodySupporterList_SupporterList__cnSXX"};